import { Injectable } from '@angular/core';
import { environment } from '../../ngCompile/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private config: any;
    private siteKey = environment.siteKey; 

    getApiKey(): string {
        return this.siteKey;
    }
}